import { api } from '$lib/api';
import { getLocaleFromPath, langHrefWithLocale } from '$lib/locale/locale';
import type { PageLoad } from './$types';
import { AssetType, assetLink, getAssetFromUrl } from '$lib/utils/asset';
import type { Track } from '$lib/models/track';
import { error, redirect } from '@sveltejs/kit';

export const load: PageLoad = async ({ fetch, params, url }) => {
  const locale = getLocaleFromPath(url.pathname);
  const asset = params.asset;
  const slug = params.slug;
  const assetType = getAssetFromUrl(asset);
  const id = params.id;

  let endpoint = '';
  if (assetType === AssetType.SFX) {
    endpoint = `/v1/sfx/${id}?slug=${slug}&lang=${locale}`;
  } else if (assetType === AssetType.Intro) {
    endpoint = `/v1/intros/${id}?slug=${slug}&lang=${locale}`;
  } else if (assetType === AssetType.Track) {
    endpoint = `/v1/tracks/${id}?slug=${slug}&lang=${locale}`;
  } else {
    throw new Error(`Asset type not supported`);
  }

  let assetFetch: Track | undefined;
  try {
    assetFetch = await api<Track>(fetch, endpoint);
  } catch (e) {
    error(404, {
      id: '404',
      message: 'Not found',
    });
  }
  const assetData = assetFetch as Track;

  // We need to redirect to the new slug if one was supplied.
  // This is because asset slugs can be edited and we don't
  // want to break old links (SEO!).
  if (assetData.newSlug) {
    const fixedLink = assetLink((href: string) => langHrefWithLocale(href, locale), assetData);
    redirect(301, fixedLink);
  }

  return {
    asset: assetData,
    assetType: assetType,
  };
};
